import store from "../store/index"
import app from "../api/application"
import {
    clientId,
    clientSecret,
    PublicKey
} from "@/http/config";


/**
 * 密码加密
 * @param sourceStr
 * @returns {string}
 */
function doSm3AndSm2Encrypt(sourceStr) {
    /* eslint-disable */
    const sm2Utils = new Sm2Utils();
    const public_key = PublicKey;
    const sm3_random_plain =
        Sm3Utils.encryptFromText(sourceStr) +
        "|" +
        sm2Utils.randomWord(8) +
        "|" +
        sourceStr;
    const sm3_sm2_plain = sm2Utils.encryptFromText(
        public_key,
        sm3_random_plain
    );
    return "{crypto}" + sm3_sm2_plain;
    /* eslint-enable */
}

// 自动登录
export async function autologin(userId) {
    const code = parseInt(Math.random() * 100000)
    const params = {
        "clientId": clientId,
        "clientSecret": clientSecret,
        "password": doSm3AndSm2Encrypt(code),
        "grantType": "password_double",
        "userId": userId
    }
    const res = (await app.autoLogin(params)).data
    sessionStorage.setItem('token', res.access_token)
    store.commit('SET_TOKEN', res.access_token)
    store.commit('SET_REFRESH_TOKEN', res.refresh_token)
    await store.dispatch('GetUserInfo', res)
    return res
}
